import { Box, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { Helmet } from 'react-helmet';

export const ExpiredLink: React.FC = () => (
  <>
    <Helmet>
      <title>Vayu: Customer Portal</title>
    </Helmet>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh",
        textAlign: "center",
        p: 2,
        bgcolor: "background.default"
      }}>
      <VyIcon icon="LogoBlue" className="text-transparent" fontSize="extra-large" />

      <Box sx={{
        mt: 3
      }}>
        <Typography variant="h4" gutterBottom>
          Your link has expired
        </Typography>
        <Typography variant="body1">Please request a new link</Typography>
      </Box>
    </Box>
  </>
);
